import type { Reducer, Effect } from 'umi';
import _ from 'lodash';

import { fetchPermissions, updatePermission, deletePermission } from './services';
import type { FetchPermissionResp, PermissionStateType } from './permission.data';
import type { ConnectState } from '@/models/connect';
import { message } from 'antd';

export type PermissionModelType = {
  namespace: string;
  state: PermissionStateType;
  effects: {
    fetchPermissions: Effect;
    updatePermission: Effect;
    deletePermission: Effect;
  };
  reducers: {
    fetchPermissionsSuccess: Reducer<PermissionStateType>;
  };
};

const Model: PermissionModelType = {
  namespace: 'permission',

  state: {
    list: [],
    query: {
      page: 1,
      limit: 10,
    },
    total: 0,
  },

  effects: {
    *fetchPermissions({ payload: updatedParams }, { call, put, select }) {
      const currentQuery = yield select((state: ConnectState) => state.user.query);

      const query = _.pickBy({ ...currentQuery, ...updatedParams }, (value) => value !== '');

      const response: FetchPermissionResp = yield call(fetchPermissions, _.omitBy(query, _.isNil));

      yield put({
        type: 'fetchPermissionsSuccess',
        payload: {
          list: response.list,
          total: response.total,
          query,
        },
      });
    },
    *updatePermission({ payload: { tourSellId, data } }, { call }) {
      yield call(updatePermission, tourSellId, data);
    },
    *deletePermission({ payload }, { call, put }) {
      const response = yield call(deletePermission, payload);

      if (response?.success) {
        message.success('The permission has been deleted.').then(() => {});
        yield put({
          type: 'fetchPermissions',
        });
      }
    },
  },
  reducers: {
    fetchPermissionsSuccess(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default Model;
